var React = require('react');

function LchtgstLogoOnlyWhitePaths (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: #fff;\n      }\n    ")),React.createElement("path",{"className":"cls-1","d":"M63.29.69H27.37A26.3,26.3,0,0,0,1.07,27h0a26.29,26.29,0,0,0,26.3,26.3H63.29A26.3,26.3,0,0,0,89.59,27h0A26.31,26.31,0,0,0,63.3.69ZM28.22,47.44A20.45,20.45,0,1,1,48.7,27,20.44,20.44,0,0,1,28.22,47.44Z","transform":"translate(-1.07 -0.69)","key":1})]);
}

LchtgstLogoOnlyWhitePaths.defaultProps = {"id":"logo_only_white_paths","data-name":"Ebene 1","width":"88.52","height":"52.61","viewBox":"0 0 88.52 52.61"};

module.exports = LchtgstLogoOnlyWhitePaths;

LchtgstLogoOnlyWhitePaths.default = LchtgstLogoOnlyWhitePaths;
